import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { fmtParts } from '@/utils';
import style from './style.module.scss';
export default function Amt({ value, currency, sign }) {
    const p = fmtParts(value, currency);
    return (_jsxs(_Fragment, { children: [sign, p.prefix, p.integer, p.decimal && _jsx("span", { className: style['frac'], children: p.decimal }), p.suffix] }));
}
